import { render } from "./PaymentRecurrenceSwitch.vue?vue&type=template&id=1d522871"
import script from "./PaymentRecurrenceSwitch.vue?vue&type=script&lang=js"
export * from "./PaymentRecurrenceSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__